module.exports = __webpack_public_path__ + "static/media/default_seo.cf2dbbba.png";